import { NavbarMobileLayout } from 'app/fuse-layouts/layout2/components/NavbarMobileLayout2';
import { memo } from 'react';

export default memo(NavbarMobileLayout);
